import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { auth } from '@/api/endpoints'
import { Alert, Field, Input, Spinner } from '@/components/ui'

export default function ForgotPasswordPage() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [busy, setBusy] = useState(false)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    try {
      await auth.forgotPassword(email)
      setSent(true)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
      <div className="card w-full max-w-sm p-6">
        <h1 className="mb-1 text-lg font-semibold">{t('auth.forgotTitle')}</h1>
        <p className="mb-5 text-sm text-slate-500">{t('auth.forgotHelp')}</p>

        {sent ? (
          <Alert variant="success">
            Ak účet existuje, poslali sme e-mail s odkazom na obnovu hesla.
          </Alert>
        ) : (
          <form onSubmit={onSubmit} className="space-y-3">
            <Field label={t('auth.email')}>
              <Input
                type="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>
            <button type="submit" className="btn-primary w-full justify-center" disabled={busy}>
              {busy ? <Spinner /> : null}
              {t('global.confirm')}
            </button>
          </form>
        )}

        <Link to="/login" className="mt-4 block text-center text-sm text-brand-600 hover:underline">
          {t('auth.backToLogin')}
        </Link>
      </div>
    </div>
  )
}
